!function(factory){"use strict";"function"==typeof define&&define.amd?define(["jquery"],factory):jQuery&&!jQuery.fn.hoverIntent&&factory(jQuery)}(function($){"use strict";var cX,cY,_cfg={interval:100,sensitivity:6,timeout:0},INSTANCE_COUNT=0,track=function(ev){cX=ev.pageX,cY=ev.pageY},compare=function(ev,$el,s,cfg){if(Math.sqrt((s.pX-cX)*(s.pX-cX)+(s.pY-cY)*(s.pY-cY))<cfg.sensitivity)return $el.off(s.event,track),delete s.timeoutId,s.isActive=!0,ev.pageX=cX,ev.pageY=cY,delete s.pX,delete s.pY,cfg.over.apply($el[0],[ev]);s.pX=cX,s.pY=cY,s.timeoutId=setTimeout(function(){compare(ev,$el,s,cfg)},cfg.interval)},delay=function(ev,$el,s,out){return delete $el.data("hoverIntent")[s.id],out.apply($el[0],[ev])};$.fn.hoverIntent=function(handlerIn,handlerOut,selector){var instanceId=INSTANCE_COUNT++,cfg=$.extend({},_cfg);$.isPlainObject(handlerIn)?(cfg=$.extend(cfg,handlerIn),$.isFunction(cfg.out)||(cfg.out=cfg.over)):cfg=$.isFunction(handlerOut)?$.extend(cfg,{over:handlerIn,out:handlerOut,selector:selector}):$.extend(cfg,{over:handlerIn,out:handlerIn,selector:handlerOut});var handleHover=function(e){var ev=$.extend({},e),$el=$(this),hoverIntentData=$el.data("hoverIntent");hoverIntentData||$el.data("hoverIntent",hoverIntentData={});var state=hoverIntentData[instanceId];state||(hoverIntentData[instanceId]=state={id:instanceId}),state.timeoutId&&(state.timeoutId=clearTimeout(state.timeoutId));var mousemove=state.event="mousemove.hoverIntent.hoverIntent"+instanceId;if("mouseenter"===e.type){if(state.isActive)return;state.pX=ev.pageX,state.pY=ev.pageY,$el.off(mousemove,track).on(mousemove,track),state.timeoutId=setTimeout(function(){compare(ev,$el,state,cfg)},cfg.interval)}else{if(!state.isActive)return;$el.off(mousemove,track),state.timeoutId=setTimeout(function(){delay(ev,$el,state,cfg.out)},cfg.timeout)}};return this.on({"mouseenter.hoverIntent":handleHover,"mouseleave.hoverIntent":handleHover},cfg.selector)}});

// initializing
(function() {
    $(document).ready(function() {
        SwellConfig.Link.initializeLinks(".swell-link-login, .swell-link-register");
        SwellConfig.LocalStorage.initializeLocalStorage();

        // After loading the form elements, detect click on the submit button wrapper and fire the facebook func
        function rewardsFinishLoading () {
            $("#sendBtnClicked").on('click', function() {
                fbq('trackCustom', 'ShareDiscount', {promotion: 'share_discount_30'});
            });
        };

        $(document).on("swell:setup", function() {
            Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
            SwellConfig.Campaign.authenticate();
            SwellConfig.Tier.initializeDummyTier();
            SwellConfig.Tier.initializeCustomTierProperties();
            SwellConfig.Tier.initializeTiers(".swell-tier-table");
            Swell.Redemption.initializeProductRedemptions(".swell-redemption-option-list", SwellConfig.Redemption.opts);
            SwellConfig.Referral.initializeReferral(".swell-referral");
            SwellConfig.Customer.initializeHistory(".swell-history-link");
            swellAPI.refreshEmbeds();

            $(".swell-campaign-content[data-campaign-id=443193] .swell-campaign-image").css("max-width", "67px");

            $(".swell-referral-loader").hide();
            rewardsFinishLoading();
            $(".redeem-spinner").hide();
            $(".alaskan-king-post-checkout").css("display", "flex");

            $( 'body' ).on('click',".alaskan-king-post-checkout .checkout-heading .swell-referral-back-link", function() {
                $(".alaskan-king-post-checkout").hide();
            });

            if(spapi.authenticated) {
                perks = spapi.customer.perks;
                perks.forEach(function(perk) {
                    campaign_id = perk.campaign_id;
                    if(campaign_id && typeof(perk.campaign_id) != undefined && campaign_id != 443194) {
                        $(".swell-campaign-content[data-campaign-id="+campaign_id +"]").addClass("completed");
                    }
                });

                if(spapi.customer.is_member) {
                    $(".swell-campaign-content[data-campaign-id=443193]").addClass("completed");
                }
            }

            setupReferrals();

            $( document ).on('click',"#swell-referral-register-submit", function() {
                setTimeout(function(){
                    if(spapi.customer.referral_receipts) {
                        setupReferrals();
                        if(spapi.customer.email) {
                            $(".swell-referral-content-main").addClass("refer-step");
                        }
                    } else {
                        setTimeout(function(){
                            setupReferrals();
                            if(spapi.customer.email) {
                                $(".swell-referral-content-main").addClass("refer-step");
                            }
                        },1000)
                    }
                },1000)
            });

            $(document).on("swell:referral:success", function() {
                swellAPI.refreshCustomerDetails(function(){
                    var customerDetails = swellAPI.getCustomerDetails();
                    referrals = customerDetails.referrals;

                    $(".redeem-holder").show();

                    $(".swell-referral-table tbody").html("");

                    referrals.forEach(function(referral) {
                        status = null;

                        if(referral.completedAt){
                            status = "Purchased(" + spapi.activeReferralCampaign.reward_text + " earned)";
                        } else {
                            status = "Invited";
                        }

                        $(".swell-referral-table tbody").append('<tr> <td>' +  referral.email + '</td><td>' + status +'</td></tr>');
                    });
                });
            });

            $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
                if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
                    $(".refer-customer-error").remove();
                    $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
                    $("#swell-referral-refer-emails").addClass("error-border");
                }
                if(textStatus && textStatus === "Please enter a valid email address"){
                    $(".refer-customer-error").remove();
                    $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
                    $("#swell-referral-refer-emails").addClass("error-border");
                }
            });
        });
    });
}).call(this);

function setupReferrals (){
    if(spapi.customer.email) {
        if(spapi.customer.referral_receipts.length > 0) {
            $(".redeem-holder").show();

            referrals = spapi.customer.referral_receipts;

            referrals.forEach(function(referral) {
                status = null;

                if(referral.completed_at){
                    status = "Purchased(" + spapi.activeReferralCampaign.reward_text + " earned)";
                } else {
                    status = "Invited";
                }

                $(".swell-referral-table tbody").append('<tr> <td>' +  referral.email + '</td><td>' + status +'</td></tr>');
            });
        }
    }
}

// campaigns
(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Campaign = {
        opts: {
            templates: {
                campaign: '<li class="swell-campaign"> <div class="swell-campaign-content" data-display-mode="modal" data-campaign-id="<%= campaign.id %>"> <div class="swell-campaign-image"> <img class="swell-campaign-image-content" src="<%= campaign.background_image_url %>" alt="<%= campaign.title %>"> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content"><%= campaign.reward_text %></span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content"><%= campaign.title %></span> </div> </div> </li>',
                campaignHover: "<div class=\"swell-campaign-hover\">\n  <div class=\"swell-campaign-hover-content\">\n    <ul class=\"swell-link-list\">\n      <li class=\"swell-link\">\n        <a href=\"/account/login\" class=\"swell-link-login\">Sign In</a>\n      </li>\n      <li class=\"swell-link\">\n        <a href=\"/account/register\" class=\"swell-link-register\">Sign Up</a>\n      </li>\n    </ul>\n  </div>\n</div>"
            }
        },
        authenticate: function() {
            if (!spapi.authenticated) {
                spapi.$(document).off("click", ".swell-campaign-content");
                $(".swell-campaign").addClass("swell-campaign-login");
                return $(".swell-campaign-content").hover(function() {
                    return $(this).append(SwellConfig.Campaign.opts.templates.campaignHover);
                }, function() {
                    return $(this).find(".swell-campaign-hover").remove();
                });
            } else {
                $(".swell-campaign-content").css('cursor', 'pointer');
            }
        }
    };
}).call(this);


// history popup
(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Customer = {
        initializeHistory: function(containerSelector) {
            return $(containerSelector).click(function() {
                return swellAPI.showPopupByType("HistoryPopup");
            });
        }
    };
}).call(this);

// links
(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Link = {
        initializeLinks: function(containerSelector) {
            return $(document).on("click", containerSelector, function(e) {
                var href;
                e.preventDefault();
                href = $(this).attr("href");
                localStorage.setItem("swell-location", "/pages/rewards");
                return window.location = href;
            });
        }
    };
}).call(this);

// local storage
(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.LocalStorage = {
        initializeLocalStorage: function() {
            var location;
            location = localStorage.getItem("swell-location");
            if (location && window.location.pathname === '/account') {
                localStorage.removeItem("swell-location");
                return window.location = location;
            }
        }
    };
}).call(this);

// redemption
(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Redemption = {
        opts: {
            templates: {
                redemptionOptionProduct: '<li class="swell-redemption-option"> <div class="swell-redemption-option-content swell-buy-product-btn" data-redemption-option-id="<%= redemption.id %>" data-variant-id="<%= redemption.applies_to_id %>"> <div class="swell-redemption-image"> <img src="<%= redemption.background_image_url %>" class="swell-redemption-image-content" alt="background image" role="presentation"> </div> <div class="swell-redemption-option-value"> <%= redemption.name %> </div> <div class="swell-redemption-option-cost"> <%= redemption.cost_text %> </div> </div> </li>'
            }
        }
    };
}).call(this);

// referral
(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Referral = {
        opts: {
            localization: {
                referralSidebarDetailsAction: "",
                referralSidebarDetailsReward: "<%= referralCampaign.reward_text %>",

                referralRegisterHeading: "<span class='refer-heading'>Refer a Friend</span>Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
                referralRegisterFormDetails: "",
                referralRegisterFormEmail: "Submit your email to get started...",
                referralRegisterFormSubmit: "NEXT",
                referralRegisterDetails: "<%= referralCampaign.details %>",

                referralReferHeading: "<span class='refer-heading'>Refer a Friend</span>Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
                referralReferFormEmails: "your friends’ emails (separated by commas)",
                referralReferFormSubmit: "SEND",
                referralReferFormDetails: "",
                referralReferFormEmailsDetails: "",
                referralReferDetails: "<%= referralCampaign.details %>",

                referralReferMediaDetails: "You can also share your link with the buttons below.",

                referralShareFacebook: "Share",
                referralShareTwitter: "Twitter",
                referralShareCopy: "Copy Link",
                referralShareMessenger: "Messenger",
                referralShareSMS: "SMS",

                referralFacebookIcon: "swell-icon-facebook",
                referralLinkIcon: "swell-icon-link",
                referralMessengerIcon: "swell-icon-messenger",
                referralSMSIcon: "swell-icon-message",

                referralThanksHeading: "Thanks for Referring!",
                referralThanksDetails: "Remind your friends to check their emails.",

                referralCopyHeading: "",
                referralCopyButton: "COPY LINK",
                referralCopyDetails: "Copy link and share with your friends."
            },
            templates: {
                referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"> <%= localization.referralRegisterDetails %> </p> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"> <%= localization.referralRegisterFormDetails %> </p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <label class="visually-hidden" for="swell-referral-register-email">Submit your email</label> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </li> </ul> </div> </form> </div> </div>',
                referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"> <%= localization.referralReferDetails %> </p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"> <%= localization.referralReferFormDetails %> </p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <label class="visually-hidden" for="swell-referral-refer-emails">Referred emails</label> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> <span class="swell-referral-form-field-details"><%= localization.referralReferFormEmailsDetails %></span> </li> <li class="swell-referral-form-list-field" id="sendBtnClicked"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"> <%= localization.referralReferMediaDetails %> </p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralSMSIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareSMS%> </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"> <span class="path1"></span> <span class="path2"></span> </i> &nbsp; <span><%= localization.referralShareMessenger %> </span> </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareCopy %> </div> </li> </ul> </div> </div>',
                referralCopy: ' <div class="swell-referral-copy"> <div class="swell-referral-copy-content"> <div class="swell-referral-copy-sidebar"></div> <div class="swell-referral-copy-main"> <div class="close-link"><span class="swell-referral-back-link"></span></div> <h2 class="swell-referral-heading"> <i class="swell-referral-heading-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralCopyHeading %> </h2> <div class="swell-referral-form-wrapper"> <div class="swell-referral-copy-link" id="swell-referral-copy-link"> <%= customer.referralLink %> </div> <button class="swell-referral-copy-button" id="swell-referral-copy-button" data-clipboard-target="#swell-referral-copy-link"> <%= localization.referralCopyButton %> </button> <p class="swell-referral-details"> <%= localization.referralCopyDetails %> </p> </div> </div> </div> </div>'
            }
        },
        initializeReferral: function(containerSelector) {
            var email = $(containerSelector).data("customer-email");
            if (email) {
                spapi.storage.setItem("referrer_email", email);
                spapi.customer.email = email;
            }
            Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
        }
    };
}).call(this);

// tiers
(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Tier = {
        getCustomerTierId: function() {
            var customer_tier, intro_tier, tiers;
            customer_tier = spapi.customer.vip_tier;
            tiers = spapi.activeVipTiers;
            if (customer_tier) {
                return customer_tier.id;
            } else {
                intro_tier = $.grep(tiers, function(e) {
                    return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
                });
                if (intro_tier.length > 0) {
                    return intro_tier[0].id;
                } else {
                    return null;
                }
            }
        },
        getCustomerTierRank: function() {
            var customer_tier, intro_tier, rank, tiers;
            customer_tier = spapi.customer.vip_tier;
            tiers = spapi.activeVipTiers;
            if (customer_tier && customer_tier.id) {
                rank = $.grep(tiers, function(e) {
                    return e.id === customer_tier.id;
                })[0].rank;
                return rank;
            } else {
                intro_tier = $.grep(tiers, function(e) {
                    return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
                });
                if (intro_tier.length > 0) {
                    return intro_tier[0].rank;
                } else {
                    return null;
                }
            }
        },
        getTierByRank: function(rank) {
            var tiers;
            tiers = spapi.activeVipTiers;
            return $.grep(tiers, function(e) {
                return e.rank === rank;
            })[0];
        },

        initializeDummyTier: function () {
            var k, len, tier, tiers;
            tiers = spapi.activeVipTiers;
            for (k = 0, len = tiers.length; k < len; k++) {
                tier = tiers[k];
                tier.rank += 1;
            }
            return tiers.unshift({
                id: -1,
                rank: 0,
                name: "Member",
                swellrequiredAmountSpent: "$0",
                swellrequiredAmountSpentCents: 0,
                swellrequiredPointsEarned: 0,
                swellrequiredPurchasesMade: 0,
                swellrequiredReferralsCompleted: 0
            });
        },
        setupCustomerTierStatus: function() {
            var $tierStatusRow, $tierValueRow, col, columnLength, customer_tier_id, customer_tier_rank, data_id, dollar_difference, encouragement, index, k, l, next_tier, ref, ref1;
            customer_tier_id = SwellConfig.Tier.getCustomerTierId();
            customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
            next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
            $(".swell-tier-table").addClass("swell-tier-status");
            $(".swell-tier-table thead").prepend("<tr class=\"swell-tier-status-row\">\n  <th scope=\"row\"></th>\n</tr>");
            $("[data-tier-id=\"" + customer_tier_id + "\"]").addClass("swell-tier-active");
            $("[data-tier-id=\"" + customer_tier_id + "\"]").removeClass("disable");

            tiers = spapi.activeVipTiers;
            tiers.forEach(function(tier) {
                if(customer_tier_id != null && tier.id  == customer_tier_id) {
                    customer_tier = tier;
                }
            });

            tiers.forEach(function(tier) {
                if(typeof(customer_tier) != "undefined" && tier.rank == customer_tier.rank) {
                    $(".swell-tier-table thead .swell-tier-status-row").append('<th scope="col"> <span class="current-status">Current Status <span class="arrow-down"></span></span> </th>');
                } else {
                    $(".swell-tier-table thead .swell-tier-status-row").append('<th scope="col"> </th>');
                }
            });
        },
        initializeCustomTierProperties: function() {
            spapi.activeVipTiers[0].points = "($0 - $999 Lifetime Spend)";
            spapi.activeVipTiers[0].one_point_multiplier = "1X";
            spapi.activeVipTiers[0].birthday_reward = "125 Points";
            spapi.activeVipTiers[0].tier_entry = "100 Points";
            spapi.activeVipTiers[0].voucher = "X";
            spapi.activeVipTiers[0].early_access = "";
            spapi.activeVipTiers[0].merchandise_giveaway = "";
            spapi.activeVipTiers[0].seasonal_offers = "";

            spapi.activeVipTiers[1].points = "Spend $1,000";
            spapi.activeVipTiers[1].one_point_multiplier = "1.5X";
            spapi.activeVipTiers[1].birthday_reward = "$10 Voucher";
            spapi.activeVipTiers[1].tier_entry = "200 Points";
            spapi.activeVipTiers[1].voucher = "X";
            spapi.activeVipTiers[1].early_access = "X";
            spapi.activeVipTiers[1].merchandise_giveaway = "";
            spapi.activeVipTiers[1].seasonal_offers = "";


            spapi.activeVipTiers[2].points = "Spend $2,500";
            spapi.activeVipTiers[2].one_point_multiplier = "2X";
            spapi.activeVipTiers[2].birthday_reward = "$15 Voucher";
            spapi.activeVipTiers[2].tier_entry = "300 Points";
            spapi.activeVipTiers[2].voucher = "X";
            spapi.activeVipTiers[2].early_access = "X";
            spapi.activeVipTiers[2].merchandise_giveaway = "X";
            spapi.activeVipTiers[2].seasonal_offers = "";


            spapi.activeVipTiers[3].points = "Spend $5,000";
            spapi.activeVipTiers[3].one_point_multiplier = "2.5X";
            spapi.activeVipTiers[3].birthday_reward = "$20 Voucher";
            spapi.activeVipTiers[3].tier_entry = "400 Points";
            spapi.activeVipTiers[3].voucher = "X";
            spapi.activeVipTiers[3].early_access = "X";
            spapi.activeVipTiers[3].merchandise_giveaway = "X";
            spapi.activeVipTiers[3].seasonal_offers = "X";
        },
        initializeTiers: function(containerSelector) {
            var i, j, key, properties, property, ref, ref1, tiers;
            if ($(containerSelector).length === 0) {
                return "";
            }
            tiers = spapi.activeVipTiers;
            properties = {
                header: {
                    points: {
                        className: "swell-tier-values",
                        title: ""
                    },
                    name: {
                        className: "swell-tier-names",
                        title: "Benefits"
                    }
                },
                body: {
                    one_point_multiplier: {
                        title: "Earn Points per $1 Spent"
                    },
                    birthday_reward: {
                        title: "Birthday Reward"
                    },
                    tier_entry: {
                        title: "Tier Entry Reward"
                    },
                    voucher: {
                        title: "$30 Voucher When You Refer a Friend"
                    },
                    early_access: {
                        title: "Early Access to Sales "
                    },
                    merchandise_giveaway: {
                        title: "Merchandise Giveaways"
                    },
                    seasonal_offers: {
                        title: "Exclusive Seasonal Offers"
                    }
                }
            };
            $(containerSelector).append("<thead></thead>");
            $(containerSelector).append("<tbody></tbody>");
            j = 0;
            ref = properties.header;
            for (key in ref) {
                property = ref[key];
                $(containerSelector).find("thead").append("<tr class=\"" + property.className + "\">\n  <th scope=\"row\">" + property.title + "</th>\n</tr>");
                tiers.forEach(function(tier) {
                    return $(containerSelector).find("thead tr:eq(" + j + ")").append("<th scope=\"col\" data-tier-id=\"" + tier.id + "\">" + tier[key] + "</th>");
                });
                j++;
            }
            i = 0;
            ref1 = properties.body;
            for (key in ref1) {
                property = ref1[key];
                $(containerSelector).find("tbody").append("<tr>\n  <td scope=\"row\">" + property.title + "</td>\n</tr>");
                tiers.forEach(function(tier) {
                    return $(containerSelector).find("tbody tr:eq(" + i + ")").append("<td data-tier-id=\"" + tier.id + "\">" + tier[key] + "</td>");
                });
                i++;
            }
            if (spapi.authenticated) {
                $(".swell-tier-table th").addClass("disable");
                $(".swell-tier-table td").addClass("disable");
                SwellConfig.Tier.setupCustomerTierStatus();
            }
        }
    };
}).call(this);

